webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(181),
  /* template */
  __webpack_require__(263),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(282);



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  scrollBehavior: function scrollBehavior() {
    return { y: 0 };
  },
  routes: [{
    path: '/404',
    name: '404',
    component: __webpack_require__(235)
  }, {
    path: '*',
    redirect: '404'
  }, {
    path: '/',
    name: 'Index',
    component: __webpack_require__(243)
  }, {
    path: '/transportloesninger',
    name: 'Products',
    component: __webpack_require__(245),
    children: [{
      path: 'stykgods',
      name: 'ProductsStykgods',
      component: __webpack_require__(250)
    }, {
      path: 'hellast',
      name: 'ProductsHellast',
      component: __webpack_require__(248)
    }, {
      path: 'bulk',
      name: 'ProductsBulk',
      component: __webpack_require__(246)
    }, {
      path: 'koel-frys',
      name: 'ProductsKoel',
      component: __webpack_require__(249)
    }, {
      path: 'farligt-gods',
      name: 'ProductsFarligt',
      component: __webpack_require__(247)
    }, {
      path: 'fragtfirma',
      name: 'ProductsFragtfirma',
      component: __webpack_require__(242)
    }]
  }, {
    path: '/hvem-er-vi',
    name: 'About',
    component: __webpack_require__(236)
  }, {
    path: '/hvem-er-vi-ny',
    name: 'AboutNew',
    component: __webpack_require__(237)
  }, {
    path: '/kontakt',
    name: 'Contact',
    component: __webpack_require__(238)
  }, {
    path: '/miljo-og-sikkerhed',
    name: 'Environment',
    component: __webpack_require__(241)
  }, {
    path: '/bliv-ringet-op-tak',
    name: 'ContactSuccess',
    component: __webpack_require__(239)
  }, {
    path: '/privatlivspolitik',
    name: 'Privacy',
    component: __webpack_require__(244)
  }, {
    path: '/covid-19',
    name: 'Covid',
    component: __webpack_require__(240)
  }]
}));

/***/ }),
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(284);



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
    state: {},
    modules: {}
}));

/***/ }),
/* 151 */,
/* 152 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(204)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(178),
  /* template */
  __webpack_require__(261),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  null,
  /* template */
  __webpack_require__(269),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(180),
  /* template */
  __webpack_require__(255),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_axios__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_moment__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_es6_promise_auto__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_es6_promise_auto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_es6_promise_auto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_raven_js__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_raven_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_raven_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_raven_js_plugins_vue__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_raven_js_plugins_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_raven_js_plugins_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__deveodk_vue_seo__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__deveodk_vue_seo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__deveodk_vue_seo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__deveodk_vue_toastr__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__deveodk_vue_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__deveodk_vue_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__deveodk_vue_toastr_dist_deveodk_vue_toastr_css__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__deveodk_vue_toastr_dist_deveodk_vue_toastr_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__deveodk_vue_toastr_dist_deveodk_vue_toastr_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__deveodk_vue_error_tracker__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__deveodk_vue_error_tracker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__deveodk_vue_error_tracker__);











__WEBPACK_IMPORTED_MODULE_8_raven_js___default.a.addPlugin(__WEBPACK_IMPORTED_MODULE_9_raven_js_plugins_vue___default.a, __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]).install();
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$raven = __WEBPACK_IMPORTED_MODULE_8_raven_js___default.a;


__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_10__deveodk_vue_seo___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_3_axios___default.a);
__WEBPACK_IMPORTED_MODULE_3_axios___default.a.defaults.baseURL = '';



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_11__deveodk_vue_toastr___default.a, {
    defaultPosition: 'toast-bottom-right',
    defaultType: 'info',
    defaultTimeout: 5000
});


__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_13__deveodk_vue_error_tracker___default.a, {
    HttpDriver: __webpack_require__(143),
    NotificationDriver: __webpack_require__(144),
    ReportDriver: __webpack_require__(145),
    HttpErrorCodes: {
        401: {
            title: 'Ingen adgang',
            message: 'Du har ikke adgang til at se dette',
            type: 'error'
        },
        400: {
            title: 'Ukendt fejl',
            message: 'Noget gik galt',
            type: 'error'
        },

        500: {
            title: 'Server fejl',
            message: 'Åhh nej noget er gået galt',
            type: 'error'
        }
    }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vue_moment___default.a);
__webpack_require__(5);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('contact-cta', __webpack_require__(157));
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('img-component', __webpack_require__(158));

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
    el: '#app',
    store: __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */],
    router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
    template: '<App/>',
    components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),
/* 178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  components: {
    'layout': __webpack_require__(234)
  }
});

/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        name: {
            required: true,
            type: String
        },
        position: {
            required: true,
            type: String
        },
        image: {
            required: false,
            type: String
        }
    }
});

/***/ }),
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        src: { type: String, required: true },
        text: { type: String, required: false }
    }
});

/***/ }),
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['title']
});

/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        title: {
            required: true,
            type: String
        },
        issuer: {
            required: true,
            type: String
        },
        link: {
            required: true,
            type: String
        }
    }
});

/***/ }),
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__certificate_vue__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__certificate_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__certificate_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        Certificate: __WEBPACK_IMPORTED_MODULE_0__certificate_vue___default.a
    }
});

/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        title: {
            required: true,
            type: String
        },
        issuer: {
            required: true,
            type: String
        },
        link: {
            required: true,
            type: String
        }
    }
});

/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__document_vue__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__document_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__document_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        Document: __WEBPACK_IMPORTED_MODULE_0__document_vue___default.a
    }
});

/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		return {
			phonenumber: '',
			contactSuccess: false
		};
	},

	methods: {
		callMe: function callMe() {
			var _this = this;

			this.contactSuccess = true;
			var templateParams = {
				'phonenumber': this.phonenumber
			};
			window.emailjs.send('sendgrid', 'template_lwwNmNI8', templateParams).then(function (response) {
				console.log('SUCCESS!', response.status, response.text);
				_this.contactSuccess = true;
				_this.$router.push({ name: 'ContactSuccess' });
			}, function (error) {
				console.log('FAILED...', error);
			});
		}
	}
});

/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            date: ''
        };
    },
    created: function created() {
        this.date = new Date().getFullYear();
    }
});

/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            showMobileMenu: false,
            links: [{
                slug: 'FreightCompany',
                name: 'Fragtfirma'
            }, {
                slug: 'Environment',
                name: 'Miljø'
            }, {
                slug: 'Covid',
                name: 'COVID-19'
            }, {
                slug: 'About',
                name: 'Hvem er vi'
            }, {
                slug: 'Contact',
                name: 'Kontakt os'
            }]
        };
    },

    methods: {
        mobileMenuToggle: function mobileMenuToggle() {
            this.showMobileMenu = !this.showMobileMenu;
        }
    },
    watch: {
        '$route.name': 'mobileMenuToggle'
    }
});

/***/ }),
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__header__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__footer__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__footer__);




/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        'site-header': __WEBPACK_IMPORTED_MODULE_0__header___default.a,
        'site-footer': __WEBPACK_IMPORTED_MODULE_1__footer___default.a
    }
});

/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_elements_employee__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_elements_employee___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_elements_employee__);




/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        Employee: __WEBPACK_IMPORTED_MODULE_0__components_elements_employee___default.a
    }
});

/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_elements_product__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_elements_product___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_elements_product__);



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Fragtfirma',
    components: {
        'product': __WEBPACK_IMPORTED_MODULE_0__components_elements_product___default.a
    }
});

/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_elements_slider__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_elements_slider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_elements_slider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_index_index_boxes__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_index_index_boxes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_index_index_boxes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_index_promo__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_index_promo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_index_promo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_index_certificates__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_index_certificates___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_index_certificates__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_index_documents__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_index_documents___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_index_documents__);







/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        'slider': __WEBPACK_IMPORTED_MODULE_0__components_elements_slider___default.a,
        'index-boxes': __WEBPACK_IMPORTED_MODULE_1__components_index_index_boxes___default.a,
        'promo': __WEBPACK_IMPORTED_MODULE_2__components_index_promo___default.a,
        'certificates': __WEBPACK_IMPORTED_MODULE_3__components_index_certificates___default.a,
        'documents': __WEBPACK_IMPORTED_MODULE_4__components_index_documents___default.a
    }
});

/***/ }),
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_elements_product__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_elements_product___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_elements_product__);



/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            products: [{
                name: 'Stykgods / Partigods',
                slug: 'stykgods'
            }, {
                name: 'Hellast / Full load',
                slug: 'hellast'
            }, {
                name: 'Bulk',
                slug: 'bulk'
            }, {
                name: 'Køl / Frys',
                slug: 'koel-frys'
            }, {
                name: 'Farligt gods / ADR',
                slug: 'farligt-gods'
            }, {
                name: 'Fragtfirma',
                slug: 'fragtfirma'
            }]
        };
    },

    components: {
        'product': __WEBPACK_IMPORTED_MODULE_0__components_elements_product___default.a
    }
});

/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_elements_product__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_elements_product___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_elements_product__);



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Koel',
    components: {
        'product': __WEBPACK_IMPORTED_MODULE_0__components_elements_product___default.a
    }
});

/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_elements_product__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_elements_product___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_elements_product__);



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Farligt Gods',
    components: {
        'product': __WEBPACK_IMPORTED_MODULE_0__components_elements_product___default.a
    }
});

/***/ }),
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_elements_product__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_elements_product___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_elements_product__);



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Hellast',
    components: {
        'product': __WEBPACK_IMPORTED_MODULE_0__components_elements_product___default.a
    }
});

/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_elements_product__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_elements_product___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_elements_product__);



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Koel',
    components: {
        'product': __WEBPACK_IMPORTED_MODULE_0__components_elements_product___default.a
    }
});

/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_elements_product__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_elements_product___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_elements_product__);



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Stykgods',
    components: {
        'product': __WEBPACK_IMPORTED_MODULE_0__components_elements_product___default.a
    }
});

/***/ }),
/* 199 */,
/* 200 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 201 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 202 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 203 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 204 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 205 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 206 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 207 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 208 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 209 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 210 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 211 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 212 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 213 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 214 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 215 */,
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 15,
	"./af.js": 15,
	"./ar": 22,
	"./ar-dz": 16,
	"./ar-dz.js": 16,
	"./ar-kw": 17,
	"./ar-kw.js": 17,
	"./ar-ly": 18,
	"./ar-ly.js": 18,
	"./ar-ma": 19,
	"./ar-ma.js": 19,
	"./ar-sa": 20,
	"./ar-sa.js": 20,
	"./ar-tn": 21,
	"./ar-tn.js": 21,
	"./ar.js": 22,
	"./az": 23,
	"./az.js": 23,
	"./be": 24,
	"./be.js": 24,
	"./bg": 25,
	"./bg.js": 25,
	"./bm": 26,
	"./bm.js": 26,
	"./bn": 27,
	"./bn.js": 27,
	"./bo": 28,
	"./bo.js": 28,
	"./br": 29,
	"./br.js": 29,
	"./bs": 30,
	"./bs.js": 30,
	"./ca": 31,
	"./ca.js": 31,
	"./cs": 32,
	"./cs.js": 32,
	"./cv": 33,
	"./cv.js": 33,
	"./cy": 34,
	"./cy.js": 34,
	"./da": 5,
	"./da.js": 5,
	"./de": 37,
	"./de-at": 35,
	"./de-at.js": 35,
	"./de-ch": 36,
	"./de-ch.js": 36,
	"./de.js": 37,
	"./dv": 38,
	"./dv.js": 38,
	"./el": 39,
	"./el.js": 39,
	"./en-SG": 40,
	"./en-SG.js": 40,
	"./en-au": 41,
	"./en-au.js": 41,
	"./en-ca": 42,
	"./en-ca.js": 42,
	"./en-gb": 43,
	"./en-gb.js": 43,
	"./en-ie": 44,
	"./en-ie.js": 44,
	"./en-il": 45,
	"./en-il.js": 45,
	"./en-nz": 46,
	"./en-nz.js": 46,
	"./eo": 47,
	"./eo.js": 47,
	"./es": 50,
	"./es-do": 48,
	"./es-do.js": 48,
	"./es-us": 49,
	"./es-us.js": 49,
	"./es.js": 50,
	"./et": 51,
	"./et.js": 51,
	"./eu": 52,
	"./eu.js": 52,
	"./fa": 53,
	"./fa.js": 53,
	"./fi": 54,
	"./fi.js": 54,
	"./fo": 55,
	"./fo.js": 55,
	"./fr": 58,
	"./fr-ca": 56,
	"./fr-ca.js": 56,
	"./fr-ch": 57,
	"./fr-ch.js": 57,
	"./fr.js": 58,
	"./fy": 59,
	"./fy.js": 59,
	"./ga": 60,
	"./ga.js": 60,
	"./gd": 61,
	"./gd.js": 61,
	"./gl": 62,
	"./gl.js": 62,
	"./gom-latn": 63,
	"./gom-latn.js": 63,
	"./gu": 64,
	"./gu.js": 64,
	"./he": 65,
	"./he.js": 65,
	"./hi": 66,
	"./hi.js": 66,
	"./hr": 67,
	"./hr.js": 67,
	"./hu": 68,
	"./hu.js": 68,
	"./hy-am": 69,
	"./hy-am.js": 69,
	"./id": 70,
	"./id.js": 70,
	"./is": 71,
	"./is.js": 71,
	"./it": 73,
	"./it-ch": 72,
	"./it-ch.js": 72,
	"./it.js": 73,
	"./ja": 74,
	"./ja.js": 74,
	"./jv": 75,
	"./jv.js": 75,
	"./ka": 76,
	"./ka.js": 76,
	"./kk": 77,
	"./kk.js": 77,
	"./km": 78,
	"./km.js": 78,
	"./kn": 79,
	"./kn.js": 79,
	"./ko": 80,
	"./ko.js": 80,
	"./ku": 81,
	"./ku.js": 81,
	"./ky": 82,
	"./ky.js": 82,
	"./lb": 83,
	"./lb.js": 83,
	"./lo": 84,
	"./lo.js": 84,
	"./lt": 85,
	"./lt.js": 85,
	"./lv": 86,
	"./lv.js": 86,
	"./me": 87,
	"./me.js": 87,
	"./mi": 88,
	"./mi.js": 88,
	"./mk": 89,
	"./mk.js": 89,
	"./ml": 90,
	"./ml.js": 90,
	"./mn": 91,
	"./mn.js": 91,
	"./mr": 92,
	"./mr.js": 92,
	"./ms": 94,
	"./ms-my": 93,
	"./ms-my.js": 93,
	"./ms.js": 94,
	"./mt": 95,
	"./mt.js": 95,
	"./my": 96,
	"./my.js": 96,
	"./nb": 97,
	"./nb.js": 97,
	"./ne": 98,
	"./ne.js": 98,
	"./nl": 100,
	"./nl-be": 99,
	"./nl-be.js": 99,
	"./nl.js": 100,
	"./nn": 101,
	"./nn.js": 101,
	"./pa-in": 102,
	"./pa-in.js": 102,
	"./pl": 103,
	"./pl.js": 103,
	"./pt": 105,
	"./pt-br": 104,
	"./pt-br.js": 104,
	"./pt.js": 105,
	"./ro": 106,
	"./ro.js": 106,
	"./ru": 107,
	"./ru.js": 107,
	"./sd": 108,
	"./sd.js": 108,
	"./se": 109,
	"./se.js": 109,
	"./si": 110,
	"./si.js": 110,
	"./sk": 111,
	"./sk.js": 111,
	"./sl": 112,
	"./sl.js": 112,
	"./sq": 113,
	"./sq.js": 113,
	"./sr": 115,
	"./sr-cyrl": 114,
	"./sr-cyrl.js": 114,
	"./sr.js": 115,
	"./ss": 116,
	"./ss.js": 116,
	"./sv": 117,
	"./sv.js": 117,
	"./sw": 118,
	"./sw.js": 118,
	"./ta": 119,
	"./ta.js": 119,
	"./te": 120,
	"./te.js": 120,
	"./tet": 121,
	"./tet.js": 121,
	"./tg": 122,
	"./tg.js": 122,
	"./th": 123,
	"./th.js": 123,
	"./tl-ph": 124,
	"./tl-ph.js": 124,
	"./tlh": 125,
	"./tlh.js": 125,
	"./tr": 126,
	"./tr.js": 126,
	"./tzl": 127,
	"./tzl.js": 127,
	"./tzm": 129,
	"./tzm-latn": 128,
	"./tzm-latn.js": 128,
	"./tzm.js": 129,
	"./ug-cn": 130,
	"./ug-cn.js": 130,
	"./uk": 131,
	"./uk.js": 131,
	"./ur": 132,
	"./ur.js": 132,
	"./uz": 134,
	"./uz-latn": 133,
	"./uz-latn.js": 133,
	"./uz.js": 134,
	"./vi": 135,
	"./vi.js": 135,
	"./x-pseudo": 136,
	"./x-pseudo.js": 136,
	"./yo": 137,
	"./yo.js": 137,
	"./zh-cn": 138,
	"./zh-cn.js": 138,
	"./zh-hk": 139,
	"./zh-hk.js": 139,
	"./zh-tw": 140,
	"./zh-tw.js": 140
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 216;

/***/ }),
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(206)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(179),
  /* template */
  __webpack_require__(265),
  /* scopeId */
  "data-v-60724a37",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(203)

var Component = __webpack_require__(1)(
  /* script */
  null,
  /* template */
  __webpack_require__(260),
  /* scopeId */
  "data-v-3f24d32a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(201)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(182),
  /* template */
  __webpack_require__(258),
  /* scopeId */
  "data-v-21cd0f4b",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(183),
  /* template */
  __webpack_require__(256),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(214)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(184),
  /* template */
  __webpack_require__(277),
  /* scopeId */
  "data-v-c704b5d2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(185),
  /* template */
  __webpack_require__(252),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(211)

var Component = __webpack_require__(1)(
  /* script */
  null,
  /* template */
  __webpack_require__(271),
  /* scopeId */
  "data-v-7cc1dd32",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(210)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(186),
  /* template */
  __webpack_require__(270),
  /* scopeId */
  "data-v-7691807a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(205)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(187),
  /* template */
  __webpack_require__(264),
  /* scopeId */
  "data-v-5ebecd11",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(212)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(188),
  /* template */
  __webpack_require__(272),
  /* scopeId */
  "data-v-7ff13103",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(200)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(189),
  /* template */
  __webpack_require__(257),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(202)

var Component = __webpack_require__(1)(
  /* script */
  null,
  /* template */
  __webpack_require__(259),
  /* scopeId */
  "data-v-301a1469",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  null,
  /* template */
  __webpack_require__(279),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  null,
  /* template */
  __webpack_require__(275),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(213)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(190),
  /* template */
  __webpack_require__(274),
  /* scopeId */
  "data-v-9daa725e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  null,
  /* template */
  __webpack_require__(281),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  null,
  /* template */
  __webpack_require__(266),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(207)

var Component = __webpack_require__(1)(
  /* script */
  null,
  /* template */
  __webpack_require__(267),
  /* scopeId */
  "data-v-63722278",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(191),
  /* template */
  __webpack_require__(253),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(192),
  /* template */
  __webpack_require__(273),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  null,
  /* template */
  __webpack_require__(251),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(209)
__webpack_require__(208)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(193),
  /* template */
  __webpack_require__(268),
  /* scopeId */
  "data-v-68273503",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(194),
  /* template */
  __webpack_require__(278),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(195),
  /* template */
  __webpack_require__(262),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(196),
  /* template */
  __webpack_require__(280),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(197),
  /* template */
  __webpack_require__(254),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(198),
  /* template */
  __webpack_require__(276),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 251 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "custom-page-title"
  }, [_c('h3', [_vm._v("\n            Privatlivspolitik / GDPR\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "container pd-50"
  }, [_c('h4', [_vm._v("\n            Registrering af personoplysninger:\n        ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("\n            Når vi leverer/afhenter varer til eller fra dig, registrerer vi de oplysninger vi har brug for til at kunne udføre transport opgaven. Det vil typisk være navn, adresse, telefonnummer, mailadresse samt et eventuelt CVR nummer. Informationerne bruges også i vores økonomisystem til fakturering.\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n            Alle oplysninger vi registrerer, behandles fortroligt og i henhold til persondataloven GDPR (General Data Protection Regulation).\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n            Vi overdrager ikke oplysningerne til nogen med mindre varerne skal overdrages til tredjepart for udførelse af transport opgaven.\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n            Jf. persondataloven har du har ret til indsigt i, hvilke oplysninger der er registreret om dig og din virksomhed, og det er altid muligt at gøre indsigelse mod registreringen.\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n            Hos Fragt og Vognmandsfirma P. Pedersen & Søn Ærø gemmes oplysningerne i minimum 5 år, fordi bogføringsloven stiller krav om opbevaring af regnskabsmateriale i 5 år.\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n            For yderligere information er du altid velkommen til at henvende dig til os.\n        ")])])])
}]}

/***/ }),
/* 252 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-4 col-lg-offset-1 col-md-6 col-sm-12"
  }, [_c('h2', [_vm._v("\n        Dokumenter\n    ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-bottom": "40px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('document', {
    attrs: {
      "title": "Kontrolrapport",
      "issuer": "Fødevarestyrelsen",
      "link": "/static/images/kontrolrapport.pdf"
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 253 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('product', {
    attrs: {
      "title": "Fragtfirma"
    }
  }, [_c('div', {
    attrs: {
      "slot": "description"
    },
    slot: "description"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "30px",
      "display": "none"
    }
  }, [_c('div', {
    staticClass: "col-lg-6"
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "border-radius": "4px"
    },
    attrs: {
      "src": "https://placehold.it/500x250"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "border-radius": "4px"
    },
    attrs: {
      "src": "https://placehold.it/500x250"
    }
  })])]), _vm._v(" "), _c('h2', {
    staticStyle: {
      "margin-top": "30px",
      "font-size": "20px"
    }
  }, [_vm._v("\n            Fragt og Vognmandsfirma P. Pedersen & Søn Ærø\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n            Hos Fragt og Vognmandsfirma P. Pedersen & Søn Ærø bliver du mødt af en erfaren og fleksibel chauffør. Vores kerneværdier som vi arbejder efter er at være fleksible, effektive og professionelle og altid i tæt dialog med kunderne.\n        ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "30px 0"
    }
  }, [_c('contact-cta')], 1), _vm._v(" "), _c('h3', {
    staticStyle: {
      "margin-top": "30px",
      "font-size": "16px"
    }
  }, [_vm._v("\n            Fragtfirma\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n            Alle transportopgaver udføres professionelt, og vi sikre at dine varer kommer sikkert fra A til B. Vi står for et tæt samarbejde med kunderne, og vi lægger stor vægt på transportydelser af højeste kvalitet, punktlighed og til lave omkostninger. I tilfælde af evt. afvigelser vil du altid blive hurtigt informeret.\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n            Fragt og Vognmandsfirma P. Pedersen & Søn Ærø tilbyder transport, kurer- og varekørsel.\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n            Ønsker du et erfarent fragtfirma med sikkerheden i orden er Fragt og Vognmandsfirma P. Pedersen & Søn Ærø det helt rigtige valg.\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('div', {
    staticClass: "col-lg-6"
  }, [_c('h4', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v("\n                    Kurerkørsel af forskellige slags\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    Kurerkørsel er en transportmulighed for de af vores kunder som skal have transporteret noget her og nu til en specifik adresse. \n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    Fragt og Vognmandsfirma P. Pedersen & Søn Ærø har stor erfaring med transport, kurer- og varekørsel af hasteleveringer til hele landet. \n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    Vi afdækker gennem en indledende samtale hvilken opgave og hvilken vare I måtte have behov for at få fragtet. Det vigtigste for os er, at alle vores kunder bliver tilfredse med det arbejde vi udfører. Vi er i tæt dialog med vores kunder, hvor vi forventningsafstemmer og snakker om dine individuelle behov.\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    Samtalen vil bl.a. indeholde:\n                    "), _c('ul', [_c('li', [_vm._v("Er det en hastesag?")]), _vm._v(" "), _c('li', [_vm._v("Hvad skal leveres?")]), _vm._v(" "), _c('li', [_vm._v("Hvor lang er ruten?")])])]), _vm._v(" "), _c('p', [_vm._v("\n                    Vi ønsker at afdække disse behov bedst muligt med vores fleksible og professionelle løsninger. Vi er af den overbevisning, at du som kunde ikke skal betale for mere end højst nødvendigt, og fordi vi ønsker at være konkurrencedygtige. \n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('h4', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v("\n                        Hvad er kurerkørsel?\n                    ")]), _vm._v(" "), _c('p', [_vm._v("\n                        Kurerkørsel betyder flere former for transport som kan være i en lille varebil. Forsendelserne kan være alt fra breve og dokumenter til små – og store pakker, ligesom kurerkørsel kan være her og nu opgaver med ekspres levering til/fra kunder.\n                    ")]), _vm._v(" "), _c('p', [_vm._v("\n                        Fragt og Vognmandsfirma P. Pedersen & Søn Ærø kan også tilbyde en fast kurer aftale.\n                    ")]), _vm._v(" "), _c('p', [_vm._v("\n                        Vi er aldrig længere end et opkald væk. Har du en kurerkørsel du skal have løst så; \n                    ")]), _vm._v(" "), _c('p', [_vm._v("\n                        Kontakt os på telefon 40 43 60 78 eller på e-mail karsten@p-pedersen.dk for at drøfte dine behov for vognmandskørsel, helt uforpligtende. Vi giver dig altid et godt tilbud på fragt.\n                    ")])])])])])])
},staticRenderFns: []}

/***/ }),
/* 254 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('product', {
    attrs: {
      "title": "Køl / Frys"
    }
  }, [_c('div', {
    attrs: {
      "slot": "description"
    },
    slot: "description"
  }, [_c('p', [_vm._v("\n            P. Pedersen & Søn transporterer temperaturkontrollerede køl- og frostvarer med temperaturer ned til -30 grader.\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n            P. Pedersen & Søn har certificering inden for fødevaresikkerhed og fødevarehygiejne.\n        ")]), _vm._v(" "), _c('p'), _c('div', {
    staticClass: "btn-holder alt"
  }, [_c('a', {
    staticClass: "btn-primary text-center text-uppercase active md-round",
    attrs: {
      "href": "/static/images/kontrolrapport.pdf",
      "rel": "noopener",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-file-o fa-fw"
  }), _vm._v(" Se certifikat\n                ")]), _vm._v("\n                Certifikatet kan også findes på Fødevarestyrelsens hjemmeside. ")]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', [_c('img', {
    staticClass: "product-image",
    attrs: {
      "src": "/static/images/koel_frys.jpg"
    }
  })])])])
},staticRenderFns: []}

/***/ }),
/* 255 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "position": "relative",
      "margin-bottom": "20px"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "margin-bottom": "0px"
    },
    attrs: {
      "src": _vm.src
    }
  }), _vm._v(" "), (_vm.text) ? _c('div', {
    staticStyle: {
      "position": "absolute",
      "right": "0px",
      "bottom": "0px",
      "background": "#8b0000",
      "color": "#fff",
      "font-size": "12px",
      "padding": "2px 6px"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.text)
    }
  }) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 256 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-7 col-md-6 col-sm-12"
  }, [_c('h2', [_vm._v("\n        Certifikater\n    ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-bottom": "40px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('certificate', {
    attrs: {
      "title": "Transport af foder",
      "issuer": "Fødevarestyrelsen",
      "link": "/static/images/pp_fodertransport_certifikat.pdf"
    }
  }), _vm._v(" "), _c('certificate', {
    attrs: {
      "title": "Transport af farligt gods (ADR)",
      "issuer": "Energistyrelsen",
      "link": "/static/images/pp_farligtgods_certifikat.png"
    }
  }), _vm._v(" "), _c('certificate', {
    attrs: {
      "title": "Bevis for Indsamleruddannelse",
      "issuer": "Miljøministeriet",
      "link": "/static/images/indsamleruddannelse.pdf"
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 257 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "wrapper"
    }
  }, [_c('site-header'), _vm._v(" "), _c('main', {
    attrs: {
      "id": "main"
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('router-view')], 1)], 1), _vm._v(" "), _c('site-footer')], 1)
},staticRenderFns: []}

/***/ }),
/* 258 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12"
  }, [_c('a', {
    attrs: {
      "href": _vm.link,
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "certificate"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "certificate__title"
  }, [_vm._v("\n                " + _vm._s(_vm.title) + "\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "certificate__issuer"
  }, [_vm._v("\n                " + _vm._s(_vm.issuer) + "\n            ")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "certificate__icon"
  }, [_c('span', {
    staticClass: "fa-stack fa-2x"
  }, [_c('i', {
    staticClass: "fas fa-circle fa-stack-2x"
  }), _vm._v(" "), _c('i', {
    staticClass: "fal fa-file-certificate fa-stack-1x fa-inverse"
  })])])
}]}

/***/ }),
/* 259 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "error-page-wrapper"
  }, [_c('div', {
    staticClass: "error-page-inner"
  }, [_c('h1', [_vm._v("404")]), _vm._v(" "), _c('h3', [_vm._v("Ups! Der er sket en fejl ...")]), _vm._v(" "), _c('p', [_vm._v("Vi ved ikke helt hvad der er sket, men vi kan desværre ikke vise denne side. Dette kan være fordi du har forsøgt at tilgå et dødt link eller fordi du ikke har adgang til denne side.")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "a",
      "to": {
        name: _vm.$route.name
      }
    }
  }, [_c('button', {
    staticClass: "btn btn-xs btn-primary"
  }, [_vm._v("\n                Genindlæs siden\n            ")])]), _vm._v("\n        |\n        "), _c('router-link', {
    attrs: {
      "tag": "a",
      "to": {
        name: 'Index'
      }
    }
  }, [_c('button', {
    staticClass: "btn btn-xs btn-primary"
  }, [_vm._v("\n                Gå til forsiden\n            ")])])], 1)])
},staticRenderFns: []}

/***/ }),
/* 260 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "main-slider"
  }, [_c('div', {
    staticClass: "slide bg-full overlay"
  }, [_c('div', {
    staticClass: "holder"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('h1', [_vm._v("Velkommen til P. Pedersen & Søn Ærø")]), _vm._v(" "), _c('span', {
    staticClass: "sub-title"
  }, [_vm._v("Fragt- og Vognmandsfirma")])])])])])])])
}]}

/***/ }),
/* 261 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('layout')], 1)
},staticRenderFns: []}

/***/ }),
/* 262 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('product', {
    attrs: {
      "title": "Farligt gods / ADR"
    }
  }, [_c('div', {
    attrs: {
      "slot": "description"
    },
    slot: "description"
  }, [_c('p', [_vm._v("\n            P. Pedersen & Søn transporterer ilt og gas, fyrværkeri, cellulosefortynder, silikonefjerner, acetone,"), _c('br'), _vm._v("malerrelaterede varer samt spild etc.\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n            P. Pedersen & Søn er certificeret til at håndtere farligt gods (ADR)\n        ")]), _vm._v(" "), _c('p'), _c('div', {
    staticClass: "btn-holder alt"
  }, [_c('a', {
    staticClass: "btn-primary text-center text-uppercase active md-round",
    attrs: {
      "href": "/static/images/pp_farligtgods_certifikat.png",
      "rel": "noopener",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-file-o fa-fw"
  }), _vm._v(" Se certifikat\n                ")]), _vm._v("\n                Certifikatet kan også findes på Energistyrelsens hjemmeside. ")]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', [_c('img', {
    staticClass: "product-image",
    staticStyle: {
      "width": "calc(50% - 10px)",
      "float": "left",
      "margin-right": "10px"
    },
    attrs: {
      "src": "/static/images/farligt_gods.jpg"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "product-image",
    staticStyle: {
      "width": "calc(50% - 10px)",
      "float": "left",
      "margin-left": "10px"
    },
    attrs: {
      "src": "/static/images/farligt_gods_2.jpg"
    }
  })])])])
},staticRenderFns: []}

/***/ }),
/* 263 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-9 col-md-9 col-xs-12 product-info"
  }, [_c('h3', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _vm._t("description")], 2)
},staticRenderFns: []}

/***/ }),
/* 264 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "bg-full",
    staticStyle: {
      "background-image": "url(/static/images/img13.jpg)"
    },
    attrs: {
      "id": "footer"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "footer-area"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 text-center"
  }, [_c('p', [_vm._v(_vm._s(_vm.date) + " © P. Pedersen & Søn\n                          |  \n                        CVR: 60098018\n                          |  \n                        Udviklet af "), _c('a', {
    staticClass: "brand-link",
    attrs: {
      "href": "https://deveo.dk",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_vm._v("Deveo")])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer-holder container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-3 col-md-6 col-sm-12"
  }, [_c('h3', [_vm._v("Kontakt os")])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-md-6 col-sm-12"
  }, [_c('ul', {
    staticClass: "list-unstyled contactlist"
  }, [_c('li', {
    staticStyle: {
      "color": "#fff"
    }
  }, [_c('i', {
    staticClass: "icon fal fa-phone"
  }), _vm._v(" "), _c('span', {
    staticClass: "tel"
  }, [_c('a', {
    attrs: {
      "href": "tel:+4540436078"
    }
  }, [_vm._v("40 43 60 78")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-md-6 col-sm-12"
  }, [_c('ul', {
    staticClass: "list-unstyled contactlist"
  }, [_c('li', {
    staticStyle: {
      "color": "#fff"
    }
  }, [_c('i', {
    staticClass: "icon fal fa-envelope"
  }), _vm._v(" "), _c('span', {
    staticClass: "mail"
  }, [_c('a', {
    attrs: {
      "href": "mailto:karsten@p-pedersen.dk"
    }
  }, [_vm._v("karsten@p-pedersen.dk")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-md-6 col-sm-12"
  }, [_c('ul', {
    staticClass: "list-unstyled contactlist"
  }, [_c('li', {
    staticStyle: {
      "color": "#fff"
    }
  }, [_c('i', {
    staticClass: "icon fal fa-home"
  }), _vm._v(" "), _c('address', [_vm._v("Nørrebro 23, 5985 Søby Ærø")])])])])])])
}]}

/***/ }),
/* 265 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-6 col-sm-12"
  }, [_c('div', {
    staticClass: "employee-box"
  }, [_c('div', {
    staticClass: "image"
  }, [(_vm.image) ? _c('img', {
    attrs: {
      "src": _vm.image
    }
  }) : _c('img', {
    attrs: {
      "src": "/static/images/avatar.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v("\n                " + _vm._s(_vm.name) + "\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "position"
  }, [_vm._v("\n                " + _vm._s(_vm.position) + "\n            ")])])])])
},staticRenderFns: []}

/***/ }),
/* 266 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "custom-page-title"
  }, [_c('h3', [_vm._v("\n            COVID-19\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "container pd-50"
  }, [_c('p', [_vm._v("\n            Situationen omkring Corona-virus udvikler sig hele tiden og hos Fragt og Vognmandsfirma P. Pedersen & Søn Ærø følger vi udviklingen nøje.\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n            Vi er opmærksomme på smittefaren og ved, at vi har et særligt ansvar i at finde løsninger og drage omsorg for både kunder og personale.\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n            Vores chauffører har derfor fået klare retningslinjer for, hvordan vi ved læsning / losning agerer for at minimere og reducere smitterisikoen.\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n            Alle vores biler har naturligvis håndsprit i førerhuset. \n        ")])])])
}]}

/***/ }),
/* 267 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "custom-page-title"
  }, [_c('h3', [_vm._v("\n            Miljø & sikkerhed\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "container pd-50"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12"
  }, [_c('h2', [_vm._v("\n                    Miljø- og sikkerhedskrav\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    P. Pedersen & Søn ved vores virksomhed er med til at påvirke miljøet og det samfund vi er en del af bl.a. gennem CO2udslip. Derfor udskifter vi løbende vores biler så vi overholder gældende EU normer.\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    P. Pedersen & Søn:\n                    \n                    ")]), _c('div', {
    staticClass: "flex-wrapper"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fal fa-boxes fa-fw"
  })]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v("\n                            Tager ansvar for kundernes varer\n                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "flex-wrapper"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fal fa-tree-alt fa-fw"
  })]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v("\n                            Tager ansvar for miljøet\n                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "flex-wrapper"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fal fa-file-alt fa-fw"
  })]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v("\n                            Har chauffører, som ALTID er opdaterede med gældende kurser og uddannelser\n                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "flex-wrapper"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fal fa-file-certificate fa-fw"
  })]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v("\n                            Har altid opdaterede tilladelser / certificeringer inden for fødevaresikkerhed og fødevarehygiejne, farligt gods mm. i henhold til gældende love og regler\n                        ")])]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12"
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "border-radius": "4px"
    },
    attrs: {
      "src": "/static/images/snow.jpg"
    }
  })])])])])
}]}

/***/ }),
/* 268 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "container pd-50 products-wrapper"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-3 col-md-3 col-xs-12"
  }, [_c('div', {
    staticClass: "products-menu"
  }, [_c('h4', [_vm._v("\n                        Transportløsninger\n                    ")]), _vm._v(" "), _c('p', [_vm._v("\n                        Læs om de forskellige transportløsninger vi tilbyder ved at klikke på nedenstående.\n                    ")]), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._l((_vm.products), function(product) {
    return _c('router-link', {
      key: product.slug,
      attrs: {
        "to": {
          path: '/transportloesninger/' + product.slug
        },
        "tag": "a"
      }
    }, [_vm._v("\n                        " + _vm._s(product.name) + "\n                    ")])
  })], 2)]), _vm._v(" "), [_c('router-view')]], 2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "custom-page-title"
  }, [_c('h3', [_vm._v("\n            Transportløsninger\n        ")])])
}]}

/***/ }),
/* 269 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "btn-holder alt"
  }, [_c('a', {
    staticClass: "btn-primary text-center text-uppercase active md-round",
    attrs: {
      "href": "/kontakt"
    }
  }, [_c('i', {
    staticClass: "fa fa-phone fa-fw"
  }), _vm._v(" Kontakt os\n    ")])])
}]}

/***/ }),
/* 270 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "tracking-sec bg-full",
    staticStyle: {
      "background-image": "url('static/images/koel_frys.jpg')"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-7 col-md-8"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-5 col-md-4"
  }, [_c('div', {
    staticClass: "track-holder bg-full",
    staticStyle: {
      "background-image": "url('static/images/img03.jpg')"
    }
  }, [(!_vm.contactSuccess) ? _c('div', {
    staticClass: "track-form",
    attrs: {
      "action": "#"
    }
  }, [_c('fieldset', [_c('label', {
    attrs: {
      "for": "text"
    }
  }, [_vm._v("Skal vi ringe dig op?")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phonenumber),
      expression: "phonenumber"
    }],
    staticClass: "form-control md-round",
    staticStyle: {
      "color": "#000",
      "font-style": "normal"
    },
    attrs: {
      "type": "text",
      "placeholder": "Indtast dit telefonnummer"
    },
    domProps: {
      "value": (_vm.phonenumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phonenumber = $event.target.value
      }
    }
  }), _vm._v(" "), _c('p', [_vm._v("Vi bestræber os på at kontakte dig inden for 2 arbejdsdage.")]), _vm._v(" "), _c('button', {
    staticClass: "call-button btn-primary text-center text-uppercase md-round",
    on: {
      "click": _vm.callMe
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\tRING MIG OP\n\t\t\t\t\t\t\t\t\t\t\t  "), _c('i', {
    staticClass: "fas fa-chevron-right"
  })])])]) : _c('div', [_c('b', [_vm._v("Tak!")]), _c('br'), _vm._v("\n\t\t\t\t\t\t\t\t\tVi kontakter dig snarest.\n\t\t\t\t\t\t\t\t")])])])])])])])
},staticRenderFns: []}

/***/ }),
/* 271 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "service-sec container"
  }, [_c('div', {
    staticClass: "sec-text col-sm-12 col-md-6"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 button-row"
  }, [_c('div', {
    staticClass: "btn-holder"
  }, [_c('router-link', {
    staticClass: "btn-primary text-uppercase active md-round",
    attrs: {
      "tag": "a",
      "to": {
        name: 'Products'
      }
    }
  }, [_vm._v("\n                        Læs mere om vores transportløsninger  "), _c('i', {
    staticClass: "fas fa-chevron-right"
  })])], 1)])])]), _vm._v(" "), _vm._m(4)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "icon big"
  }, [_c('i', {
    staticClass: "fal fa-shipping-fast fa-fw"
  })]), _vm._v(" "), _c('div', {
    staticClass: "txt-holder"
  }, [_c('h3', {
    staticClass: "heading2"
  }, [_vm._v("Dag til dag distribution")]), _vm._v(" "), _c('p', [_vm._v("\n                        Dag til dag distribution til og fra Ærø."), _c('br'), _vm._v("\n                        P. Pedersen & Søn transporterer alt fra småpakker, stykgods, partigods eller full load, køle-/ frysevarer samt farligt gods.\n                    ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "icon big"
  }, [_c('i', {
    staticClass: "fal fa-thumbs-up fa-fw"
  })]), _vm._v(" "), _c('div', {
    staticClass: "txt-holder"
  }, [_c('h3', {
    staticClass: "heading2"
  }, [_vm._v("Anerkendte transportører")]), _vm._v(" "), _c('p', [_vm._v("\n                        Gennem samarbejde med anerkendte transportører, kan vi betjene hele landet.\n                    ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "icon big"
  }, [_c('i', {
    staticClass: "fal fa-arrows fa-fw"
  })]), _vm._v(" "), _c('div', {
    staticClass: "txt-holder"
  }, [_c('h3', {
    staticClass: "heading2"
  }, [_vm._v("Fleksible transportløsninger")]), _vm._v(" "), _c('p', [_vm._v("\n                        Fleksible transportløsninger med høj leveringssikkerhed og effektiv håndtering til fornuftige priser. Vi finder altid en løsning der passer dig.\n                    ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "icon big"
  }, [_c('i', {
    staticClass: "fal fa-handshake fa-fw"
  })]), _vm._v(" "), _c('div', {
    staticClass: "txt-holder last"
  }, [_c('h3', {
    staticClass: "heading2"
  }, [_vm._v("Siden 1921")]), _vm._v(" "), _c('p', [_vm._v("\n                        P. Pedersen & Søn Fragt og Vognmandsfirma startede i 1921 og køres i dag af tredje generation"), _vm._v(".\n                    ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sec-logo col-sm-12 col-md-6"
  }, [_c('div', [_c('img', {
    attrs: {
      "src": "/static/images/pp_logo.png"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('img', {
    staticStyle: {
      "max-width": "40%",
      "margin": "0 auto",
      "display": "block"
    },
    attrs: {
      "src": "/static/images/100_aar.png"
    }
  })])])
}]}

/***/ }),
/* 272 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    attrs: {
      "id": "header"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row header-holder"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "logo text-uppercase"
  }, [_c('router-link', {
    attrs: {
      "tag": "a",
      "to": {
        name: 'Index'
      }
    }
  }, [_c('img', {
    staticClass: "custom-logo",
    staticStyle: {
      "object-fit": "contain"
    },
    attrs: {
      "src": "/static/images/p_pedersen_logo.png"
    }
  })])], 1), _vm._v(" "), _c('a', {
    staticClass: "nav-opener",
    on: {
      "click": _vm.mobileMenuToggle
    }
  }, [_c('i', {
    staticClass: "fa fa-bars"
  })]), _vm._v(" "), _c('nav', {
    class: {
      'mobile-show': this.showMobileMenu
    },
    attrs: {
      "id": "nav"
    }
  }, [_c('ul', {
    staticClass: "list-unstyled"
  }, [_c('li', {
    staticClass: "has-children",
    class: {
      'active': _vm.$route.name.includes('Products')
    }
  }, [_vm._m(0), _vm._v(" "), _c('ul', {
    staticClass: "children-list"
  }, [_c('router-link', {
    class: {
      'selected': _vm.$route.name === 'ProductsStykgods'
    },
    attrs: {
      "tag": "li",
      "to": {
        name: 'ProductsStykgods'
      }
    }
  }, [_vm._v("\n                                    Stykgods / Partigods\n                                ")]), _vm._v(" "), _c('router-link', {
    class: {
      'selected': _vm.$route.name === 'ProductsHellast'
    },
    attrs: {
      "tag": "li",
      "to": {
        name: 'ProductsHellast'
      }
    }
  }, [_vm._v("\n                                    Hellast / Full load\n                                ")]), _vm._v(" "), _c('router-link', {
    class: {
      'selected': _vm.$route.name === 'ProductsBulk'
    },
    attrs: {
      "tag": "li",
      "to": {
        name: 'ProductsBulk'
      }
    }
  }, [_vm._v("\n                                    Bulk\n                                ")]), _vm._v(" "), _c('router-link', {
    class: {
      'selected': _vm.$route.name === 'ProductsKoel'
    },
    attrs: {
      "tag": "li",
      "to": {
        name: 'ProductsKoel'
      }
    }
  }, [_vm._v("\n                                    Køl / Frys\n                                ")]), _vm._v(" "), _c('router-link', {
    class: {
      'selected': _vm.$route.name === 'ProductsFarligt'
    },
    attrs: {
      "tag": "li",
      "to": {
        name: 'ProductsFarligt'
      }
    }
  }, [_vm._v("\n                                    Farligt gods / ADR\n                                ")]), _vm._v(" "), _c('router-link', {
    class: {
      'selected': _vm.$route.name === 'ProductsFragtfirma'
    },
    attrs: {
      "tag": "li",
      "to": {
        name: 'ProductsFragtfirma'
      }
    }
  }, [_vm._v("\n                                    Fragtfirma\n                                ")])], 1)]), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.$route.name === '???'
    }
  }, [_c('a', {
    attrs: {
      "href": "/#miljo"
    }
  }, [_vm._v("\n                                Miljø\n                            ")])]), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.$route.name === 'Covid'
    }
  }, [_c('router-link', {
    attrs: {
      "tag": "a",
      "to": {
        name: 'Covid'
      }
    }
  }, [_vm._v("\n                                COVID-19\n                            ")])], 1), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.$route.name === 'About'
    }
  }, [_c('router-link', {
    attrs: {
      "tag": "a",
      "to": {
        name: 'About'
      }
    }
  }, [_vm._v("\n                                Hvem er vi\n                            ")])], 1), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.$route.name === 'Contact'
    }
  }, [_c('router-link', {
    attrs: {
      "tag": "a",
      "to": {
        name: 'Contact'
      }
    }
  }, [_vm._v("\n                                Kontakt os\n                            ")])], 1)])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "javascript:void(0)"
    }
  }, [_vm._v("\n                                Transport\n                                "), _c('i', {
    staticClass: "fas fa-caret-down fa-fw"
  })])
}]}

/***/ }),
/* 273 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('slider'), _vm._v(" "), _c('index-boxes'), _vm._v(" "), _c('div', {
    staticStyle: {
      "background": "#141e36",
      "color": "#fff"
    }
  }, [_c('div', {
    staticClass: "container pd-50"
  }, [_c('h1', {
    staticStyle: {
      "font-size": "30px",
      "color": "#fff",
      "margin-bottom": "30px"
    }
  }, [_vm._v("\n                Transportfirma\n            ")]), _vm._v(" "), _c('h2', {
    staticStyle: {
      "font-size": "20px",
      "color": "#fff",
      "margin-bottom": "30px"
    }
  }, [_vm._v("\n                Transportfirma, Fragt og Vognmand P. Pedersen & Søn Ærø\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n                Vi er en solid og velkonsolideret transportvirksomhed med flere årtier på bagsmækken, som dagligt leverer en bred vifte af services til vores kunder. Hos os er der mulighed for at få transporteret mange forskellige slags gods. Vi kan håndtere en eller flere afhentninger af alt fra den mindste kolli op til 38 tons pr. gang.\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n                Vi kan med stolthed sige, at transport er en del af vores DNA. Vi er stolte af vores virksomhed og vores omhyggelige engagerede medarbejdere. Vi behandler godset som var det firmaets eget. Vi yder vores bedste hver dag i bestræbelserne på at give den bedst mulige service overfor vores kunder.\n            ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "30px 0"
    }
  }, [_c('contact-cta')], 1), _vm._v(" "), _c('p', [_vm._v("\n                Fragt og Vognmandsfirma P. Pedersen & Søn Ærø har altid haft en klar holdning til kvalitet, professionel håndtering, høj service og rettidig distribution. \n            ")]), _vm._v(" "), _c('p', [_vm._v("\n                Det er vigtigt for os at du har tillid til os, hvilket vi vægter højt i vores transportfirma. Vores medarbejdere er vores største styrke. Omgangstonen er uformel og vi har stor tillid til hinanden. Alle vores medarbejdere er motiverede og ansvarsbevidste, og de har en positiv tilgang til vores samarbejde med vores kunder. \n            ")]), _vm._v(" "), _c('p', [_vm._v("\n                Vi fokuserer på punktlighed hvilket betyder, at du får dine leverancer til tiden. Vi har professionelle chauffører som er uddannet til at håndtere alle typer af gods.\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n                Du kan stole på, at transportere vi dine pakker eller gods – så bliver det ansvarligt behandlet og kommer sikkert frem, da du altid får en kompetent chauffør til jobbet.\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "container pd-50"
  }, [_c('h3', {
    staticStyle: {
      "font-size": "20px"
    }
  }, [_vm._v("\n            Transportfirma i Danmark\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n            Fragt og Vognmandsfirma P. Pedersen & Søn Ærø er et transportfirma som gennem samarbejde med anerkendte transportører, kan betjene kunder i hele landet. Alle vores kunder har forskellige behov for transport, og vi gør altid vores bedste for at imødekomme disse ønsker og behov. Vi har den nødvendige viden og erfaring til at tilbyde dig individuelle ydelser, og til at skræddersy løsninger til både private- og erhvervskunder.\n        ")]), _vm._v(" "), _c('h3', {
    staticStyle: {
      "margin-top": "30px",
      "font-size": "20px"
    }
  }, [_vm._v("\n            Kurerkørsel af forskellige slags\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n            Kurerkørsel er en transportmulighed, for de af vores kunder som skal have transporteret noget her og nu og gerne til en specifik adresse.\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n            Fragt og Vognmandsfirma P. Pedersen & Søn Ærø har store erfaringer med kurerkørsel af hasteleveringer til hele landet.  Vi er i tæt dialog med vores kunder, hvor vi forventningsafstemmer og snakker om dine individuelle behov. Vi afdækker gennem en indledende samtale, hvilken opgave og hvilken vare I måtte have behov for at få kurerkørsel af.\n        ")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('p', [_vm._v("\n            Vi ønsker at afdække disse behov bedst muligt med vores fleksible og professionelle løsninger. Vi er også af den overbevisning, at du som kunde hos os ikke skal betale for mere end højst nødvendigt, og fordi vi ønsker at være konkurrencedygtige.\n        ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "margin": "30px 0"
    }
  }, [_vm._m(1), _vm._v(" "), _c('contact-cta')], 1), _vm._v(" "), _c('p', [_vm._v("\n            Hos Fragt og Vognmandsfirma P. Pedersen & Søn Ærø har du mulighed for at få transporteret mange forskellige slags gods.\n        ")])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "container pd-50",
    attrs: {
      "id": "miljo"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12"
  }, [_c('h4', {
    staticStyle: {
      "font-size": "24px"
    }
  }, [_vm._v("\n                    Fragt og Vognmandsfirma P. Pedersen & Søn Ærø har fokus på miljø og sikkerhedskrav\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    Fragt og Vognmandsfirma P. Pedersen & Søn Ærø ved at vores virksomhed er med til at påvirke miljøet og det samfund vi er en del af bl.a. gennem CO2udslip. Derfor udskifter vi løbende vores biler så vi overholder gældende EU-normer. \n                ")]), _vm._v(" "), _vm._m(3), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('p'), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('contact-cta')], 1)]), _vm._v(" "), _vm._m(9)])]), _vm._v(" "), _vm._m(10)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n            Samtalen vil bl.a. indeholde:\n            "), _c('ul', [_c('li', [_vm._v("Er det en hastesag?")]), _vm._v(" "), _c('li', [_vm._v("Hvad skal leveres?")]), _vm._v(" "), _c('li', [_vm._v("Hvor lang er ruten?")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "btn-holder alt"
  }, [_c('a', {
    staticClass: "btn-primary text-center text-uppercase active md-round",
    staticStyle: {
      "margin-right": "15px"
    },
    attrs: {
      "href": "/fragtfirma"
    }
  }, [_vm._v("\n                    Læs mere\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background": "#edf2f7",
      "padding": "30px 0",
      "border-top": "1px solid #ddd",
      "border-bottom": "1px solid #ddd"
    }
  }, [_c('div', {
    staticClass: "container pd-50"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticStyle: {
      "font-weight": "bold",
      "font-size": "20px",
      "margin-bottom": "15px"
    }
  }, [_vm._v("\n                    Stykgods / Partigods\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    Når du vælger Fragt og Vognmandsfirma P. Pedersen & Søn Ærø til distribution af dit stykgods i Danmark, vælger du et vognmandsfirma, som ønsker at være den forlængede arm ud til dig. Det betyder du med ro kan stole på, at vi transporterer dine varer sikkert, og at varerne når frem i tide i korrekt tilstand.\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    Stykgods eller partigods er en forsendelse som er over 20 kg. Vi har mulighed for at sende både enkeltvis, små kolli, eller større partier. Som ekstra service har vi også en medbringertruck til levering af dit gods, hvor vores fragtbiler ikke når ind.\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    Fragt og Vognmandsfirma P. Pedersen & Søn Ærø sender og henter dagligt småpakker og stykgods fra fastlandet til Ærø i tæt samarbejde med anerkendte transportører. Forsendelser afhentet hos en virksomhed eller indleveret på vores lager i Odense inden kl. 09:00 leveres samme dag hos modtager på Ærø. Fragt og Vognmandsfirma P. Pedersen & Søn kan betjene kunder i hele landet.\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "btn-holder alt"
  }, [_c('a', {
    staticClass: "btn-primary text-center text-uppercase active md-round",
    staticStyle: {
      "margin-right": "15px"
    },
    attrs: {
      "href": "/transportloesninger/stykgods"
    }
  }, [_vm._v("\n                        Læs mere\n                    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "box",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('div', {
    staticStyle: {
      "font-weight": "bold",
      "font-size": "20px",
      "margin-bottom": "15px"
    }
  }, [_vm._v("\n                    Bulk / Walking floor\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    Bulkgods betegner gods som transporteres u-pakket, dvs. løst (f.eks. forskellige kornarter, træpiller, flis etc.).\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    Fragt og Vognmandsfirma P. Pedersen & Søn Ærø transporterer løst gods med Walking floor trailere, som via hydraulik kan flytte lameller som ligger i bunden af traileren frem og tilbage. På den måde læsses u-pakket løst gods af i stedet for at tippe traileren. \n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    Vi mener det er den ideelle trailer til løst volume gods, da det er nemt og hurtigt at læsse godset af ved med det bevægelige gulv, og vi benytter Walking floor trailerne til flere formål.\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    Fragt og Vognmandsfirma P. Pedersen & Søn Ærø transporterer ikke alene løse foderstoffer, træflis og forskellige kornarter, men også træpiller og pallegods. Den ene Walking floor trailer kan åbnes i siden, hvilket gør det er muligt at laste og losse gods vandret i traileren. \n                ")]), _vm._v(" "), _c('div', {
    staticClass: "btn-holder alt"
  }, [_c('a', {
    staticClass: "btn-primary text-center text-uppercase active md-round",
    staticStyle: {
      "margin-right": "15px"
    },
    attrs: {
      "href": "/transportloesninger/bulk"
    }
  }, [_vm._v("\n                        Læs mere\n                    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "box",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('div', {
    staticStyle: {
      "font-weight": "bold",
      "font-size": "20px",
      "margin-bottom": "15px"
    }
  }, [_vm._v("\n                    Køl / frys\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    Transport af fryse- og kølevarer er en af Fragt og Vognmandsfirma P. Pedersen & Søn Ærø stærke kompetencer. Vi har vi nogle af landets mest moderne kølevogne, som alle opfylder markedets krav om køletransport til at fragte vores temperaturfølsomme gods. Hygiejnen er i højsæde, og vi sikre naturligvis at kølekæden ikke brydes under transporten. Det betyder du kan være sikker på at modtage dine varer med en garanteret friskhed. \n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    Dagligt transporterer Fragt og Vognmandsfirma P. Pedersen & Søn Ærø temperaturfølsomme varer til butikker, cateringfirmaer, hoteller og restauranter til hele Ærø.\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "btn-holder alt"
  }, [_c('a', {
    staticClass: "btn-primary text-center text-uppercase active md-round",
    staticStyle: {
      "margin-right": "15px"
    },
    attrs: {
      "href": "/transportloesninger/koel-frys"
    }
  }, [_vm._v("\n                        Læs mere\n                    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "box",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('div', {
    staticStyle: {
      "font-weight": "bold",
      "font-size": "20px",
      "margin-bottom": "15px"
    }
  }, [_vm._v("\n                    Farligt gods / fyrværkeri (ADR)\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    Få transporteret dit farlige gods (ADR) hos Fragt og Vognmandsfirma P. Pedersen & Søn Ærø af professionelt uddannede og godkendte chauffører. \n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    Vi sørger for at håndtere og transportere dit farlige gods (ADR) sikkert - uanset om der er tale om ilt, gas, cellulosefortynder, maling, fyrværkeri, krudt og kugler etc.\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    Hos os kan du altid trygt regne med at det farlig gods (ADR) er forsvarligt pakket og surret, og kommer sikkert frem fra afsender til modtager.\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "btn-holder alt"
  }, [_c('a', {
    staticClass: "btn-primary text-center text-uppercase active md-round",
    staticStyle: {
      "margin-right": "15px"
    },
    attrs: {
      "href": "/transportloesninger/farligt-gods"
    }
  }, [_vm._v("\n                        Læs mere\n                    ")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Fragt og Vognmandsfirma P. Pedersen & Søn Ærø:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex-wrapper"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fal fa-boxes fa-fw"
  })]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v("\n                            Tager ansvar for kundernes varer\n                        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex-wrapper"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fal fa-tree-alt fa-fw"
  })]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v("\n                            Tager ansvar for miljøet\n                        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex-wrapper"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fal fa-file-alt fa-fw"
  })]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v("\n                            Har chauffører, som altid er opdaterede med gældende kurser og uddannelser med fokus på at nedbringe arbejdsulykker\n                        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex-wrapper"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fal fa-thumbs-up fa-fw"
  })]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v("\n                            Har chauffører, som viser respekt i lokalsamfundet og agere så de altid er til mindst muligt gene på vejene\n                        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex-wrapper"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fal fa-file-certificate fa-fw"
  })]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v("\n                            Har altid opdaterede tilladelser / certificeringer inden for fødevaresikkerhed og fødevarehygiejne, farligt gods mm. i henhold til gældende love og regler\n                        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12"
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "border-radius": "4px"
    },
    attrs: {
      "src": "/static/images/snow.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container pd-50"
  }, [_c('h4', {
    staticStyle: {
      "font-size": "20px"
    }
  }, [_vm._v("\n            Lad vores Fragt og Vognmandsfirma transportere dit gods\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n            Hvis du vægter pålidelighed og professionalisme højt, så er vores Fragt og Vognmandsfirma P. Pedersen & Søn Ærø det helt rette valg for dig. Du får altid erfarne chauffører, der kender deres ansvar og opgaver. Vi har gode priser, og kan tilbyde dig et uforpligtende tilbud.\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n            Skal vores Fragt og Vognmandsfirma P. Pedersen & Søn Ærø transportere dit gods sikkert frem? Vi er aldrig længere end et opkald væk.\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n            Kontakt os allerede i dag ved at ringe på telefon 40 43 60 78 eller ved at sende en e-mail til karsten@p-pedersen.dk så vender vi hurtigst muligt tilbage.\n        ")])])
}]}

/***/ }),
/* 274 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "container pd-50"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12"
  }, [_c('h2', [_vm._v("\n                    Medarbejdere\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('employee', {
    attrs: {
      "name": "Karsten Bil Pedersen",
      "position": "Vognmand"
    }
  }), _vm._v(" "), _c('employee', {
    attrs: {
      "name": "Marianne Fly Pedersen",
      "position": "Kontor"
    }
  }), _vm._v(" "), _c('employee', {
    attrs: {
      "name": "Birger D. Petersen",
      "position": "Chauffør"
    }
  }), _vm._v(" "), _c('employee', {
    attrs: {
      "name": "Brian W. Weber",
      "position": "Chauffør"
    }
  }), _vm._v(" "), _c('employee', {
    attrs: {
      "name": "Karsten L. Pedersen",
      "position": "Chauffør"
    }
  }), _vm._v(" "), _c('employee', {
    attrs: {
      "name": "Lasse Z. Bil Pedersen",
      "position": "Chauffør"
    }
  }), _vm._v(" "), _c('employee', {
    attrs: {
      "name": "Daniel S. Nielsen",
      "position": "Chauffør"
    }
  }), _vm._v(" "), _c('employee', {
    attrs: {
      "name": "Thomas Laursen",
      "position": "Chauffør"
    }
  }), _vm._v(" "), _c('employee', {
    attrs: {
      "name": "Kenneth Larsen",
      "position": "Chauffør"
    }
  }), _vm._v(" "), _c('employee', {
    attrs: {
      "name": "Uffe S. Kajhøj",
      "position": "Chauffør"
    }
  }), _vm._v(" "), _c('employee', {
    attrs: {
      "name": "Jack Sørensen",
      "position": "Chauffør"
    }
  }), _vm._v(" "), _c('employee', {
    attrs: {
      "name": "Frits Einspor",
      "position": "Chauffør (afløser)"
    }
  }), _vm._v(" "), _c('employee', {
    attrs: {
      "name": "Hans Gert Clausen",
      "position": "Chauffør (afløser)"
    }
  }), _vm._v(" "), _c('employee', {
    attrs: {
      "name": "Lars Ole Jakobsen",
      "position": "Chauffør (afløser)"
    }
  }), _vm._v(" "), _c('employee', {
    attrs: {
      "name": "Jan Hansen",
      "position": "Chauffør (afløser)"
    }
  })], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "custom-page-title"
  }, [_c('h3', [_vm._v("\n            Kontakt os\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12"
  }, [_c('h2', [_vm._v("\n                    Kontaktoplysninger\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "contact-box"
  }, [_c('div', {
    staticStyle: {
      "border-radius": "4px",
      "overflow": "hidden"
    }
  }, [_c('iframe', {
    staticStyle: {
      "border": "0"
    },
    attrs: {
      "src": "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d9166.779387510944!2d10.245455193387553!3d54.94337173829329!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47b2d645cbd445dd%3A0xec8e91e72899cf26!2zUC4gUGVkZXJzZW4gJiBTw7huIEFwUywgU8O4Ynkgw4ZSw5g!5e0!3m2!1sda!2sdk!4v1533388978450",
      "width": "600",
      "height": "450",
      "frameborder": "0",
      "allowfullscreen": ""
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-5 col-md-6 col-sm-12"
  }, [_c('b', [_vm._v("P. Pedersen & Søn")]), _vm._v(" "), _c('br'), _vm._v("\n                            CVR: 60098018\n                            "), _c('br'), _vm._v("\n                            494100 Vejgodstransport\n                            "), _c('br'), _vm._v("\n                            P-nummer: 1002107587\n                            "), _c('br'), _vm._v("\n                            Nørrebro 23\n                            "), _c('br'), _vm._v("\n                            5985 Søby Ærø\n                            "), _c('br'), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-7 col-md-6 col-sm-12"
  }, [_c('b', [_c('i', {
    staticClass: "fas fa-phone"
  }), _vm._v("  Telefon")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    staticStyle: {
      "color": "#8b0000",
      "font-weight": "bold",
      "text-decoration": "underline",
      "font-size": "24px"
    },
    attrs: {
      "href": "tel:+4540436078"
    }
  }, [_vm._v("\n                                40 43 60 78\n                            ")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('b', [_c('i', {
    staticClass: "fas fa-envelope"
  }), _vm._v("  E-mail")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    staticStyle: {
      "color": "#8b0000",
      "font-weight": "bold",
      "text-decoration": "underline",
      "font-size": "24px"
    },
    attrs: {
      "href": "mailto:karsten@p-pedersen.dk"
    }
  }, [_vm._v("\n                                karsten@p-pedersen.dk\n                            ")])])])])])
}]}

/***/ }),
/* 275 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "about-us-page"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "container pd-50"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('img-component', {
    attrs: {
      "src": "/static/images/new/3.jpg",
      "text": "Her er en billedetekst"
    }
  })], 1), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('img', {
    staticClass: "w-full",
    attrs: {
      "src": "/static/images/new/21_foto_fra_facebook.jpeg"
    }
  })]), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), _vm._m(10), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-12"
  }, [_c('img-component', {
    attrs: {
      "src": "/static/images/new/26.jpg",
      "text": "\n                    Familien Bil tæller i dag 7 personer<br>\n                    Fra venstre Lasse, Karsten, Manna, Thomas, Peder og Matilde (Jesper mangler)\n                "
    }
  })], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "custom-page-title"
  }, [_c('h3', [_vm._v("\n            Hvem er vi\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('img', {
    staticClass: "w-full",
    attrs: {
      "src": "/static/images/new/6,2_new.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('h3', {
    staticStyle: {
      "margin": "0 0 20px"
    }
  }, [_vm._v("\n                    Historien bag P. Pedersen & Søn\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    P. Pedersen & Søn Fragt og Vognmandsfirma blev grundlagt i 1921 og køres i dag af tredje generation.\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    Det var farfaren Peter Pedersen som startede firmaet august 1921. På det tidspunkt transporterede han alt - sten og grus, gods, korn, dyr og mennesker – med både hestevogn og bil. Han havde også et grusværk med gravemaskiner og gummiged. Med tiden blev det dog fragt, vognmandskørsel og dagligvare distribution der vægtede mest – indtil hans død i 1977.\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    Sønnen Mads Pedersen begyndte i firmaet da han fik kørekort, og han overtog styringen i begyndelsen af 1970érne. Mads Pedersen døde desværre i en alder af 50 år, hvorefter hans hustru Manna Pedersen kørte virksomheden videre indtil sønnerne Peder Bil og Karsten Bil tiltrådte virksomheden i 1976.\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    Peder Bil gik på efterløn i 2011, men følger stadig interesseret med i virksomheden. I dag køres firmaet alene af Karsten Bil, som i øvrigt havde 45 års jubilæum 1. marts 2021. Karsten Bil har to sønner, Lasse som er chauffør i firmaet og Thomas som bor og arbejder på Sjælland som sælger.\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    I årene 2008–2018 havde Karsten Bil også virksomheden Kemi-Oil ApS (forhandling af cellulosefortynder, silikonefjerner og acetone samt afhentning af spild i hele landet).\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    Det gamle familiefirma, som 16. august 2021 runder 100 år, har i dag otte biler. Seks trækkere, en forvogn, en varebil + ti trailere, der dag og nat kører til og fra Ærø for at betjene beboerne, havne og virksomheder med småpakker, styk-/partigods, fødevarer, køl/frys, materialer mv.\n                ")]), _vm._v(" "), _c('p', [_c('img', {
    staticClass: "w-full",
    attrs: {
      "src": "/static/images/new/22_karsten_bil_og_peder_bil.jpg"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('img', {
    staticClass: "w-full",
    attrs: {
      "src": "/static/images/new/1_med_logo.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('img', {
    staticClass: "w-full",
    attrs: {
      "src": "/static/images/new/2.jpg"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('img', {
    staticClass: "w-full",
    attrs: {
      "src": "/static/images/new/4.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('img', {
    staticClass: "w-full",
    attrs: {
      "src": "/static/images/new/5.jpg"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-4"
  }, [_c('img', {
    staticClass: "w-full",
    attrs: {
      "src": "/static/images/new/7.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-4"
  }, [_c('img', {
    staticClass: "w-full",
    attrs: {
      "src": "/static/images/new/8.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-4"
  }, [_c('img', {
    staticClass: "w-full",
    attrs: {
      "src": "/static/images/new/6,1.jpg"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('img', {
    staticClass: "w-full",
    attrs: {
      "src": "/static/images/new/9.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('img', {
    staticClass: "w-full",
    attrs: {
      "src": "/static/images/new/10.jpg"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-3"
  }, [_c('img', {
    staticClass: "w-full",
    attrs: {
      "src": "/static/images/new/20_forvogn.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-5"
  }, [_vm._v("\n                Andet billede af hvid lastbil her - Jeg kan ikke finde billedet i de billeder, jeg har taget. Hvor kan jeg finde det i god opløsning?\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-4"
  }, [_c('img', {
    staticClass: "w-full",
    attrs: {
      "src": "/static/images/new/13.jpg"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-4"
  }, [_c('img', {
    staticClass: "w-full",
    attrs: {
      "src": "/static/images/new/24.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-4"
  }, [_c('img', {
    staticClass: "w-full",
    attrs: {
      "src": "/static/images/new/14.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-4"
  }, [_c('img', {
    staticClass: "w-full",
    attrs: {
      "src": "/static/images/new/15.jpg"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('img', {
    staticClass: "w-full",
    attrs: {
      "src": "/static/images/people.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('img', {
    staticClass: "w-full",
    attrs: {
      "src": "/static/images/new/25.jpg"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('img', {
    staticClass: "w-full",
    attrs: {
      "src": "/static/images/100_aar.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('img', {
    staticClass: "w-full",
    attrs: {
      "src": "/static/images/Galleri_2.jpg"
    }
  })])])
}]}

/***/ }),
/* 276 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-9 col-md-9 col-xs-12 product-info"
  }, [_c('h1', {
    staticStyle: {
      "margin-top": "0",
      "margin-bottom": "30px",
      "font-size": "30px"
    }
  }, [_vm._v("\n        Godstransport\n    ")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('h2', {
    staticStyle: {
      "font-size": "20px"
    }
  }, [_vm._v("\n        Godstransport mellem Fyn og Ærø\n    ")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "30px 0"
    }
  }, [_c('contact-cta')], 1), _vm._v(" "), _c('h2', {
    staticStyle: {
      "font-size": "20px"
    }
  }, [_vm._v("\n        Godstransport efter dine behov\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n        Fragt og Vognmandsfirma P. Pedersen & Søn Ærø er eksperter i godstransport mellem Fyn og Ærø. Vi varetager hver dag transport for et hav af glade kunder, og vi vil også gerne hjælpe dig. En godstransport dækker over transport og flytning af varer og produkter i alskens kategorier, lige fra letgods, tungt gods, volumen gods, farligt gods, stykgods og pallegods fra A til B.\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n        Alle vores kunder er forskellige og har forskellige behov. Derfor sammensætter vi en unik fragt og logistik løsning, som passer til dit behov, uanset om du har brug for godstransport fra din egen virksomhed, eller en fra en tredjepart. Fragt og Vognmandsfirma P. Pedersen & Søn Ærø tilbyder dig godstransport, som passer til dine behov og altid til konkurrencedygtige priser.\n    ")]), _vm._v(" "), _c('h3', {
    staticStyle: {
      "margin-top": "30px",
      "margin-bottom": "15px",
      "font-size": "16px"
    }
  }, [_vm._v("\n        Godstransport privat/erhverv\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n        Hos Fragt og Vognmandsfirma P. Pedersen & Søn Ærø får du en hurtig og personlig service af erfarne chauffører, der kender deres opgaver. Vi lægger stor vægt på god relation til vores kunder, da vi mener at gode relationer er forbundet med en stor grad af troværdighed. Vi lover aldrig mere end hvad vi kan stå indenfor, og vi tilbyder vores ydelser til såvel store -, som små private virksomheder.\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n        Vi ønsker et partnerskab med vores kunder, hvor begge parter drager nytte af hinanden – så det bliver en win win situation. Fragt og Vognmandsfirma P. Pedersen & Søn Ærø sætter en dyd i yde den bedste service, hvor vi ved at alle kunder er forskellige. Vores medarbejdere står klar til at hjælpe dig, så de kender præcis dine /jeres behov. Vælger du Fragt og Vognmandsfirma P. Pedersen & Søn Ærø får du ikke alene en effektiv løsning der matcher dine ønsker. Du får chauffører som tager ejerskab ved at udføre et kvalitetsarbejde –for på den måde at bevare et tæt samarbejde langt ud i fremtiden.\n    ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('contact-cta')], 1), _vm._v(" "), _c('h4', {
    staticStyle: {
      "margin-top": "30px",
      "margin-bottom": "15px",
      "font-size": "16px"
    }
  }, [_vm._v("\n        Godstransport med fragtbil\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n        Fragt og Vognmandsfirma P. Pedersen & Søn Ærø skræddersyer transportløsninger til dig eller din virksomhed. Vælger du os til at transportere dit gods, får du en professionel samarbejdspartner med solid erfaring og stor kapacitet, da vores erfarne chauffører er meget effektive og hurtige til at læsse og  losse dine varer.\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n        Vi kan også tilbyde faste aftaler om dagligt at afhente og fragte dine varer, og hvis tid er vigtig, ringer vi i forvejen og fortæller dig at vi er på vej. Vi har mange typer fragtbiler, som tilgodeser dig som kunde hvis du har en opgave, som kræver noget specielt.\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n        Vi har fragtbiler som både er velegnede til de mindre gader og leverancer, samt større fragtbiler, der er velegnet til kørsel af stort gods. Og overalt hvor vi kører, sørger vi for at vise respekt i lokalsamfundet – og vi lægger stor vægt på at vi er mindst muligt til gene på vejene.\n    ")])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "30px"
    }
  }, [_c('div', {
    staticClass: "col-lg-6"
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "border-radius": "4px"
    },
    attrs: {
      "src": "/static/images/stykgods_1.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "border-radius": "4px"
    },
    attrs: {
      "src": "/static/images/stykgods_2.jpg"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n        Fragt og Vognmandsfirma P. Pedersen & Søn Ærø kan hjælpe dig uanset hvilket gods du skal have transporteret, og vi klarer forsendelser af alt fra 0 kg småpakker til 38 tons.\n        "), _c('br'), _c('br'), _vm._v("\n        Forsendelser afhentet hos en virksomhed, eller indleveret på vores lager i Odense Fyn inden kl. 09:00, leveres samme dag hos modtager på Ærø.\n        "), _c('br'), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box",
    staticStyle: {
      "overflow": "hidden"
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "10px 20px",
      "background": "#172b43",
      "color": "#fff",
      "margin": "-20px -20px 20px -20px",
      "font-size": "18px",
      "font-weight": "bold",
      "padding-bottom": "15px",
      "margin-bottom": "15px"
    }
  }, [_vm._v("\n            Vi tilbyder\n        ")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Partigods")])]), _vm._v(" "), _c('p', [_vm._v("\n            Skal du eller din virksomhed sende større partier som f. eks. paller, så er det partigods transport I skal vælge. Vi afhenter partiet hos afsender til den aftalte tid, og leverer hos modtager inden for den aftale tid."), _c('br'), _c('br')]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Stykgods")])]), _vm._v(" "), _c('p', [_vm._v("\n            Stykgods er forsendelser på over 20 kg. Stykgods kan sendes enkeltvis, i små portioner eller i større partier og vi håndterer også langgods og farligt gods. Gods kan deles op i 2 typer efter vægt og rumfang. Letgods er primært gods mellem 100 kg og 1000 kg under 53 i rumfang resten benævnes sværgods.\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n            At fragte stykgods betyder enten at vi afhenter din pakke eller dine varer, og kører dem til et lager eller til en anden fragtbil, som derefter kører den ud til modtager. Eller betyder, at vi henter din pakke eller varer hos en virksomhed, lager eller anden fragtbil og fragter den til hjem til dig på Ærø. Vi gør os stor umage for at din pakke næsten ikke bliver flyttet undervejs – både for at skåne dit gods men også for at undgå skader. Stykgods kan også sendes som ekspresgods, hvis det ønskes.\n        ")])])
}]}

/***/ }),
/* 277 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-12"
  }, [_c('a', {
    attrs: {
      "href": _vm.link,
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "document"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "document__title"
  }, [_vm._v("\n                " + _vm._s(_vm.title) + "\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "document__issuer"
  }, [_vm._v("\n                " + _vm._s(_vm.issuer) + "\n            ")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "document__icon"
  }, [_c('span', {
    staticClass: "fa-stack fa-2x"
  }, [_c('i', {
    staticClass: "fas fa-circle fa-stack-2x"
  }), _vm._v(" "), _c('i', {
    staticClass: "fal fa-smile fa-stack-1x fa-inverse"
  })])])
}]}

/***/ }),
/* 278 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('product', {
    attrs: {
      "title": "Bulk"
    }
  }, [_c('div', {
    attrs: {
      "slot": "description"
    },
    slot: "description"
  }, [_c('p', [_vm._v("\n            P. Pedersen & Søn transporterer korn, halm, flis mm. i Walkingfloor trailer.\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n            P. Pedersen & Søn er certificeret til fodertransport.\n        ")]), _vm._v(" "), _c('p'), _c('div', {
    staticClass: "btn-holder alt"
  }, [_c('a', {
    staticClass: "btn-primary text-center text-uppercase active md-round",
    attrs: {
      "href": "/static/images/pp_fodertransport_certifikat.pdf",
      "rel": "noopener",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-file-o fa-fw"
  }), _vm._v(" Se certifikat\n                ")]), _vm._v("\n                Certifikatet kan også findes på Fødevarestyrelsens hjemmeside. ")]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', [_c('img', {
    staticClass: "product-image",
    staticStyle: {
      "width": "calc(50% - 10px)",
      "float": "left",
      "margin-right": "10px"
    },
    attrs: {
      "src": "/static/images/bulk_1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "product-image",
    staticStyle: {
      "width": "calc(50% - 10px)",
      "float": "left",
      "margin-left": "10px"
    },
    attrs: {
      "src": "/static/images/bulk_2.jpg"
    }
  })])])])
},staticRenderFns: []}

/***/ }),
/* 279 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "custom-page-title"
  }, [_c('h3', [_vm._v("\n            Hvem er vi\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "container pd-50"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "margin-bottom": "30px"
    },
    attrs: {
      "src": "static/images/about.jpg"
    }
  }), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "100%",
      "margin-bottmo": "30px"
    },
    attrs: {
      "src": "static/images/IMG_0296.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('h3', {
    staticStyle: {
      "margin": "0 0 20px"
    }
  }, [_vm._v("\n                    Historien bag P. Pedersen & Søn\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    P. Pedersen & Søn Fragt og Vognmandsfirma startede i 1921 og køres i dag af tredje generation.\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    Det var farfaren Peter Pedersen som startede firmaet august 1921. På det tidspunkt transporterede han alt - sten og grus, gods, korn, dyr og mennesker – med både hestevogn og bil. Han havde også et grusværk med gravemaskiner og gummiged. Med tiden blev det dog fragt, vognmandskørsel og dagligvare distribution der vægtede mest – indtil hans død i 1977.\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    Sønnen Mads Pedersen begyndte i firmaet da han fik kørekort, og han overtog styringen i begyndelsen af 1970érne. Mads Pedersen døde desværre i en alder af 50 år, hvorefter hans hustru Manna Pedersen kørte virksomheden videre indtil sønnerne Peder Bil og Karsten Bil tiltrådte virksomheden i 1976.\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    Peder Bil gik på efterløn i 2011, men følger stadig interesseret med i virksomheden. I dag køres firmaet alene af Karsten Bil, som i øvrigt havde 45 års jubilæum 1. marts 2021. Karsten Bil har to sønner, Lasse som er chauffør i firmaet og Thomas som bor og arbejder på Sjælland som sælger.\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    I årene 2008–2018 havde Karsten Bil også virksomheden Kemi-Oil ApS (forhandling af cellulosefortynder, silikonefjerner, acetone mm. samt afhentning af spild i hele landet). Efter 10 gode år blev virksomheden solgt til Bent Hansens Malervarer.\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    Det gamle familiefirma, som 16. august 2021 runder 100 år, har i dag otte biler. Seks trækkere, en forvogn, en varebil + ti trailere, der dag og nat kører til og fra Ærø med gods og varer.\n                ")]), _vm._v(" "), _c('p', [_c('img', {
    staticStyle: {
      "width": "100%",
      "margin-bottom": "30px"
    },
    attrs: {
      "src": "/static/images/people.jpg"
    }
  }), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "/static/images/Galleri_2.jpg"
    }
  })])])])])])
}]}

/***/ }),
/* 280 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('product', {
    attrs: {
      "title": "Hellast / Full load"
    }
  }, [_c('div', {
    attrs: {
      "slot": "description"
    },
    slot: "description"
  }, [_c('p', [_vm._v("\n            P. Pedersen & Søn kan håndtere én eller flere afhentninger op til 38 tons pr. gang.\n        ")]), _vm._v(" "), _c('p', [_c('img', {
    staticClass: "product-image",
    staticStyle: {
      "width": "400px",
      "max-width": "100%"
    },
    attrs: {
      "src": "/static/images/fullload.jpg"
    }
  })])])])
},staticRenderFns: []}

/***/ }),
/* 281 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "custom-page-title"
  }, [_c('h3', [_vm._v("\n            Bliv ringet op\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "container pd-50"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('h2', [_vm._v("\n                    TAK\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    Vi har nu modtaget din forespørgsel og vil ringe dig op hurtigst muligt.\n                ")])])])])])
}]}

/***/ })
],[177]);


// WEBPACK FOOTER //
// static/js/app.134ee43fade2f5ec7ccc.js